import { useWindowSize } from '../utils';

const useDesktop = () => {
  const [width] = useWindowSize();

  return width >= 992;
};

export default useDesktop;
